/**
 * Controla la tabla de inspecciones.
 */
InspeccionesDetallesCtrl.$inject = ['$log', '$scope', 'InspeccionIncidencia', 'dialogService', 'ComentarioIncidencia', '$http', '$sce'];
export default function InspeccionesDetallesCtrl($log, $scope, InspeccionIncidencia, dialogService, ComentarioIncidencia, $http, $sce) {
    var TAG = 'InspeccionesDetallesCtrl: ';

    var templateDialogAdd = require('./crearOEditInspeccionDialog.html');
    var templateDialogDel = require('./borrarInspeccionDialog.html');
    var templateDialogFin = require('./finalizarInspeccionDialog.html');

    $scope.inspecciones = [];
    $scope.user = Sigo.user;
    // No funciona pasarle un string a la directiva, así que he pasado un número, para saber si está en el panel de incidencias
    $scope.esPanelIncidencias = $scope.panel == 10;

    var tienePermisos = Sigo.user.esAdmin || (Sigo.config['permitir_inspecciones_tecnico'] && Sigo.user.esTecnico);
    $scope.puedeAnyadir = tienePermisos;
    //console.log($scope.directiva);
    //if (!$scope.esPanelInspecciones)
    //    cargarInspecciones($scope.incidenciaId);

    $scope.anyadirInspeccion = function (incidenciaId) {
        $log.debug('Añadiendo inspección a la incidencia ' + incidenciaId + ' ...');
        InspeccionIncidencia.create({incidenciaId: incidenciaId}, function (data) {
            var modelo = data;

            var primerInspector = modelo.inspectores[0].id;
            if (issetAndNotEmpty(modelo.inspectoresDistrito) && Array.isArray(modelo.inspectoresDistrito) && modelo.inspectoresDistrito.length > 0)
                primerInspector = modelo.inspectoresDistrito[0];

            modelo.inspeccion = {
                incidencia_id: incidenciaId,
                inspector_id: primerInspector
            };
            var botones = {
                botonOk: ucfirst(Lang.get('nombres.anyadir')),
                botonCancel: ucfirst(Lang.get('nombres.cancelar'))
            };

            doDialog(templateDialogAdd, modelo, ucfirst(Lang.get('nombres.anyadir')) + " " + Lang.choice('nombres.inspeccion', 1),
                "dialogCrearEditarInspeccion", botones)
                .then(function (result) {
                    anyadirInspeccionServer(incidenciaId, result.inspeccion)
                });
        }, function (error) {
            Sigo.UI.Messages.open([error.data.messages], 0);
        });
    };

    $scope.actualizar = function (incidenciaId) {
        $log.debug('Actualizando inspecciones de la incidencia ' + incidenciaId + ' ...');
        cargarInspecciones(incidenciaId);
    };

    $scope.puedeFinalizar = function (inspeccion) {
        var esElInspector = inspeccion.inspector.id == Sigo.user.user_id;
        var estaActiva = inspeccion.estado_inspeccion.id != Sigo.estado.INSPECCION.FINALIZADA;
        return (esElInspector || tienePermisos) && estaActiva;
    };

    $scope.puedeBorrar = function (inspeccion) {
        var estaActiva = inspeccion.estado_inspeccion.id != Sigo.estado.INSPECCION.FINALIZADA;
        return Sigo.user.esAdmin && estaActiva;
    };

    $scope.marcarFinalizada = function (incidenciaId, inspeccionId) {
        var botones = {
            botonOk: ucfirst(Lang.get('seccion_inspecciones.boton_finalizar')),
            botonCancel: ucfirst(Lang.get('nombres.cancelar'))
        };
        $http.get(Sigo.var.path + '/incidencias/datos-finalizar-inspeccion/' + incidenciaId).then(function (response) {
            var data = response.data;
            var entidadId = issetAndNotEmpty(data.tipoSeleccionado.entidad_reparadora_id) ? data.tipoSeleccionado.entidad_reparadora_id : '';

            var model = {
                datos: data, tipo_id: data.tipoSeleccionado.id, entidad_id: entidadId, tipo_antiguo: data.tipoSeleccionado.id,
                incidenciaEstaPendiente: data.incidenciaEstaPendiente, incidencia_id: incidenciaId
            };
            doDialog(templateDialogFin, model, ucfirst(Lang.get('nombres.finalizar')) + " " + Lang.choice('nombres.inspeccion', 1), "finalizarInspeccion",
                botones).then(function (result) {
                //var msg = result.mensaje;
                //if (msg != undefined && msg.length > 0) {
                var inspeccion = {};
                inspeccion.estado_inspeccion_id = Sigo.estado.INSPECCION.FINALIZADA;
                inspeccion.comentario = result.mensaje;
                inspeccion.resultado_id = result.resultado_id;
                if (result.incidenciaEstaPendiente) {
                    inspeccion.tipo_id = result.tipo_id;
                    inspeccion.tipo_antiguo = result.tipo_antiguo;
                    inspeccion.entidad_id = result.entidad_id;
                }
                editarInspeccionServer(incidenciaId, inspeccionId, inspeccion);
                //} else {
                //    Sigo.UI.Messages.open([Lang.get('mensajes.escribir_comentario')], 0);
                //}
            });
        });
    };

    $scope.editarInspeccion = function (incidenciaId, inspeccionId) {
        $log.debug('Editando la inspección ' + inspeccionId + ' a la incidencia ' + incidenciaId + ' ...');

        InspeccionIncidencia.edit({incidenciaId: incidenciaId, inspeccionId: inspeccionId}, function (data) {
            var botones = {
                botonOk: ucfirst(Lang.get('nombres.editar')),
                botonCancel: ucfirst(Lang.get('nombres.cancelar'))
            };

            data.finalizada = data.inspeccion.estado_inspeccion_id == Sigo.estado.INSPECCION.FINALIZADA;
            doDialog(templateDialogAdd, data, ucfirst(Lang.get('nombres.editar')) + " " + Lang.choice('nombres.inspeccion', 1), "dialogCrearEditarInspeccion",
                botones)
                .then(function (result) {
                    editarInspeccionServer(incidenciaId, inspeccionId, result.inspeccion);
                });
        }, function (error) {
            Sigo.UI.Messages.open([error.data.messages], 0);
        });
    };

    $scope.borrarInspeccion = function (incidenciaId, inspeccionId) {
        var botones = {
            botonOk: ucfirst(Lang.get('nombres.borrar')),
            botonCancel: ucfirst(Lang.get('nombres.cancelar'))
        };

        doDialog(templateDialogDel, {}, ucfirst(Lang.get('nombres.borrar')) + " " + Lang.choice('nombres.inspeccion', 1), "borrarInspeccion", botones)
            .then(function () {
                InspeccionIncidencia.delete({incidenciaId: incidenciaId, inspeccionId: inspeccionId}, function (data) {
                    $log.debug('Inspección borrada!');
                    cargarInspecciones(incidenciaId);
                    if ($scope.esPanelIncidencias)
                        actualizaFilaVIncidencia(data.vIncidencia, 0);
                });
            });

    };

    $scope.renderPrioridad = function (inspeccion) {
        var render = '';
        if (Sigo.user.puedeEditarPrioridadInspeccion || inspeccion.inspector_id == Sigo.user.user_id)
            render = linkPrioridadInspeccion(inspeccion.prioridad, 'incidencias_inspecciones', inspeccion.id);
        else
            render = InspeccionesUtils.renderPrioridad(inspeccion.prioridad);
        return $sce.trustAsHtml(render);
    };

    function cargarInspecciones(incidenciaId) {
        $log.debug(TAG + 'Cargando inspecciones de la incidencia ' + incidenciaId + '...');
        $scope.cargandoInspecciones = true;

        InspeccionIncidencia.query({
            incidenciaId: incidenciaId
        }, function (data) {
            $scope.inspecciones = data;
            $scope.cargandoInspecciones = false;
            $log.debug('Inspecciones cargadas!');
        }, function (err) {
            //TODO: Comprobar errores
            $scope.cargandoInspecciones = false;
        });
    }

    function anyadirInspeccionServer(incidenciaId, inspeccion) {
        $log.debug('Añadiendo inspeccion a la incidencia ' + incidenciaId + '...');
        InspeccionIncidencia.save({incidenciaId: incidenciaId}, inspeccion, function (data) {
            $log.debug('Inspección añadida!');
            cargarInspecciones(incidenciaId);
            if ($scope.esPanelIncidencias) {
                actualizaFilaVIncidencia(data.vIncidencia);
            }
        });
    }

    function editarInspeccionServer(incidenciaId, inspeccionId, inspeccion) {
        $log.debug('Editando la inspeccion ' + inspeccionId + 'a la incidencia ' + incidenciaId + '...');
        InspeccionIncidencia.update({incidenciaId: incidenciaId, inspeccionId: inspeccionId}, inspeccion, function (data) {
            $log.debug('Inspección editada!');
            cargarInspecciones(incidenciaId);
            if ($scope.esPanelIncidencias)
                actualizaFilaVIncidencia(data.vIncidencia);
            else
                InspeccionesUtilidades.actualizaFilaInspeccion(data.inspeccion, 0);
        });
    }

    function doDialog(template, model, titulo, idDialog, extraOptions) {
        // jQuery UI dialog options
        var options = {
            autoOpen: false,
            modal: true,
            title: titulo,
            minWidth: 600,
            minHeight: false
        };

        // Open the dialog using template from script
        return dialogService.open(idDialog, template, model, options, extraOptions);
    }

}